export default __webpack_public_path__ + "static/media/work-tip.d723dc0b.svg";